<template>
  <!--  {{this.items}}-->
  <el-form label-width="100px" class="app">
    <el-form-item label="薪资项目：">
      <el-input v-model="name" style="width: 90%" placeholder="在职奖" disabled/>
    </el-form-item>
    <el-form-item label="备注：">
      <el-input v-model="remark" style="width: 90%" :autosize="{ minRows: 3, maxRows: 6 }" type="textarea"/>
    </el-form-item>
    <h4 style="margin-left: 20px">发放规则：</h4>
    <el-form :model="form" label-width="80px" class="bordered-container">
      <el-table :data="items"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column label="" width="50">
          <template v-slot="scope">
            <el-button class="custom-circle-button" type="danger" @click="removeItem(scope.$index)" plain circle>
              <svg width="20" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="2"></line>
              </svg>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="序号" type="index" width="80"></el-table-column>
        <el-table-column label="≥最低司龄(月)">
          <template v-slot="scope">
            <el-input v-model="scope.row.min_years" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="<最高工龄(月)">
          <template v-slot="scope">
            <el-input v-model="scope.row.max_years" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="企内金额">
          <template v-slot="scope">
            <el-input v-model="scope.row.amount" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="企外金额">
          <template v-slot="scope">
            <el-input v-model="scope.row.amount_out" type="number"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <el-button class="mb-4" type="primary" plain icon="el-icon-plus"
                 @click="addItem" style="float: right;margin-top: 5px" circle></el-button>
    </el-form>

    <div style="margin-top: 7%;text-align: center ">
      <el-button type="primary" @click="saveButton">保存</el-button>
    </div>
  </el-form>
</template>
<script>
export default {
  name: "IncentiveReward",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      radiusGroup: [],
      remark: '',
      items: []
    }
  },

  methods: {
    addItem() {
      if (!this.items) {
        this.items = []
      }
      this.items.push({
        min_years: '',
        max_years: '',
        amount: '',
        amount_out: ''
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
    },
    async saveButton() {
      for (let item of this.items) {
        if (item.min_years === '' || item.max_years === '' || item.amount === '') {
          this.$message({
            message: "发放规则不能为空！",
            type: "error",
          });
          return;
        }
        if (Number(item.min_years) >= Number(item.max_years)) {
          this.$message({
            message: "最低司龄必须小于最高司龄！",
            type: "error",
          });
          return;
        }
        if (Number(item.min_years) < 0 || Number(item.max_years) < 0 || Number(item.amount) < 0 ) {
          this.$message({
            message: "发放规则不能为负数",
            type: "error",
          });
          return;
        }
      }
      for (let i = 1; i < this.items.length; i++) {
        if (Number(this.items[i].min_years) < Number(this.items[i - 1].max_years)) {
          this.$message({
            message: "最低司龄不能小于历史最高司龄！",
            type: "error",
          });
          return;
        }
      }
      let pageId = {
        id: this.parentData.id
      }
      let params = {
        items: this.items,
        remark: this.remark,
        itemId: pageId.id
      }
      await this.$http("salaryRuleConfigureService.saveIncentiveReward", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("salaryRuleConfigureService.getIncentiveRewardById", params);
        this.items = data.items
        this.remark = data.remark
      }
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped lang="less">

.demo-radius .title {
  color: var(--el-text-color-regular);
  font-size: 18px;
  margin: 10px 0;
}

.bordered-container {
  border: 0.5px solid lightgrey;
  padding: 10px 20px 45px 20px;
  width: 98%;
  margin: 10px;
}

.app {
  margin: 20px;
}
</style>